export const handleBeforeunload = (event: BeforeUnloadEvent, message: string, condition: boolean) => {
  if (condition) {
    const returnValue = message;
    event.returnValue = returnValue;
    return returnValue;
  }

  return undefined;
};
